import api from "../../api";
import { getCorporateIdFromToken } from "@/utils/corporate";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    Model: [],
  },
  getters: {
    getModel(state) {
      return state.Model;
    },
  },
  mutations: {
    SetModel(state, data) {
      state.Model = [];
      state.Model = data;
    },
  },
  actions: {
    fetchAllModel({ commit }, payload = {}) {
      return new Promise((resolve, rej) => {
        let corporateId = payload && (payload.corporateId || payload.CorporateId);
        if (!corporateId) {
          corporateId = getCorporateIdFromToken();
        }
        const body = corporateId ? { corporateId: corporateId } : {};
        api()
          .post(`Model/get_all_models`, body, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
            commit("SetModel", res.data);
          })
          .catch((err) => console.log(err));
      });
    },
    fetchModelByMake_id({ commit }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Model/get_models_by_make_id`,
            {
              id: id,
            },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);

            commit("SetModel", res.data);
          })
          .catch((err) => console.log(err));
      });
    },

    addModel({ dispatch }, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Model/add_model`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
    editModel({}, data) {
      return new Promise((resolve, rej) => {
        api()
          .post(`Model/edite_model`, data, {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },

    deleteModel({ dispatch }, id) {
      return new Promise((resolve, rej) => {
        api()
          .post(
            `Model/delete_model`,
            { id: id },
            {
              headers: {
                Authorization: localStorage.getItem("JwtToken"),
              },
            }
          )
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            resolve(err.response);
          });
      });
    },
  },
};
